import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PipelineDashboard from './pages/PipelineDashboard';
import AdminLogin from './pages/AdminLogin';
import AuthContext from './context/AuthContext';
import useAuth from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
    const { token, admin, loginAdmin, logoutAdmin } = useAuth();
    const [loading] = useState(false);

    const contextData = {
        admin,
        token,
        loginAdmin,
        logoutAdmin
    };

    return (
        <AuthContext.Provider value={contextData}>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={!token ? <AdminLogin /> : <Navigate to="/" />} />
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute token={token} loading={loading}>
                                <PipelineDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </BrowserRouter>
        </AuthContext.Provider>
    );
}

export default App;
